<template>
    <div v-if="agendas">
        <div :id="divname" v-show="false">
            <cabecalho-generico titulo="Agendas">
                <div>
                    Data: {{ lista_datas }}
                </div>
            </cabecalho-generico>

            <table class="table table-sm table-bordered small">
                <tbody>
                    <tr>
                        <th v-for="(lista_status, status, isx) in totalizador_status" :key="isx">
                            {{ status }}: {{ lista_status.length }} 
                            <div>
                                {{ Math.round( ( lista_status.length / total_geral ) * 100 ) }}%
                            </div>
                        </th>
                        <th>
                            Total: {{ total_geral }}
                        </th>
                        <th>
                            Atendidos: {{ totalizador_atendidos }}
                            <div>
                                {{ Math.round( ( totalizador_atendidos / totalizador_ocupados ) * 100 ) }}%
                            </div>
                        </th>
                    </tr>
                </tbody>
            </table>

            <table class="table table-sm small">
                <thead>
                    <tr>
                        <th>Hora</th>
                        <th>Paciente</th>
                        <th>Procedimento</th>
                        <th>Plano</th>
                        <th>Atend</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(lista, grupo, idx) in agendas">
                        <tr :key="'T' + idx" v-if="true">
                            <th colspan="5">{{ grupo }}</th>
                        </tr>
                        <tr v-for="(item, iix) in ordenar(lista)" :key="'I-' + idx + '-' + iix">
                            <td>
                                {{ item.hora }}
                            </td>
                            <td>
                                {{ item.marcacao ? item.marcacao.nome_paciente : '' }}
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.procedimento ) ? item.marcacao.procedimento.st_procedimento : '' }}
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.plano ) ? item.marcacao.plano.search : '' }}
                            </td>
                            <td>
                                {{ ( item.marcacao && item.marcacao.id_atendimento ) ? item.marcacao.id_atendimento : '' }}
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <hr> 

            <pre>{{ agendas }}</pre>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return { 
            agendas: null, 
            chave: "", 
        }
    },

    components: { 
        CabecalhoGenerico
    },

    computed: { 
        lista_datas: function() { 
            return _.uniqBy(_.flatMap(this.agendas), 'data').map(item => { 
                    return this.$util.getFormatDate(item.data);
                })
                .join(', ');
        },

        divname: function () { 
            return 'relatorio-agendas-' + this.chave; 
        },

        totalizador_status: function() { 
            return _.groupBy(_.flatMap(this.agendas), item => { 
                switch (item.status) {
                    case 'passado':
                    case 'livre':
                        return 'livre';
                }

                return item.status
            });
        },

        totalizador_ocupados: function () { 
            return _.filter(_.flatMap(this.agendas), item => { 
                return item.status == 'ocupado' ? true : false;
            }).length;
        },

        totalizador_atendidos: function () { 
            return _.filter(_.flatMap(this.agendas), item => { 
                return ( item.marcacao && item.marcacao.id_atendimento ) ? true : false;
            }).length;
        },

        total_geral: function () { 
            return _.flatMap(this.totalizador_status).length
        }
    },

    methods: {
        ordenar(lista) {
            return _.orderBy(lista, ['hora'], ['asc']);
        },

        imprimir (agendas) { 
            this.agendas = _.cloneDeep(agendas);

            this.$nextTick(() => {
                this.$htmlToPaper(this.divname, null, () => {
                    console.log("Printing");
                });                
            });
        }      
    },
}
</script>
